/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Bumbleをゲット",
      "全て承認する",
      "オプションを管理",
      "クッキーポリシー",
      "戻る",
      "電話番号が間違っています",
      "©{{current_year}}Bumble | 不許複製・禁無断転載",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "概要",
      "アンバサダー",
      "ブログ",
      "弊社はクッキーを使用しています。設定の変更が行われなかった場合、あなたはその使用に同意したとみなされます。",
      "アプリをダウンロード",
      "Android版をダウンロード",
      "iOS版をダウンロード",
      "申し訳ありません、お探しのページが見つかりません。",
      "ログイン",
      "参加",
      "仲間に入ろう！",
      "問題が発生しました"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "日"
            ],
            "singular": [
                  "日"
            ]
      },
      "hour": {
            "plural": [
                  "時間"
            ],
            "singular": [
                  "時間"
            ]
      },
      "minute": {
            "plural": [
                  "分"
            ],
            "singular": [
                  "分"
            ]
      },
      "month": {
            "plural": [
                  "ヶ月"
            ],
            "singular": [
                  "ヶ月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
